import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  graphNotOk: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    textAlign: 'center',
    fontSize: fonts.sizes.medium,
    color: colors.fontGray,
  },
  graphNotOkContent: {
    width: '100%',
  },
  graphContainer: {
    width: '100%',
    marginBottom: '-16px',
  },
  titleHeading: {
    display: 'flex',
    justifyContent: 'space-between',

    '& svg': {
      cursor: 'pointer',
    },
  },
  graphTitle: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights['extra-bold'],
    marginBottom: spacing.xsmall,
  },
});

export default useStyles;
